import { CONFERENCE_JOINED } from '../base/conference/actionTypes';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import { showNotification } from '../notifications/actions';
import { NOTIFICATION_ICON, NOTIFICATION_TIMEOUT, NOTIFICATION_TIMEOUT_TYPE } from '../notifications/constants';
import { getBrandServiceName } from '../utils/brandDomainUtils';
MiddlewareRegistry.register(({ dispatch }) => next => action => {
    switch (action.type) {
        case CONFERENCE_JOINED: {
            const notificationParams = {
                titleKey: 'notify.dataCenterTitle',
                descriptionKey: 'notify.dataCenterDescription',
                descriptionArguments: { serviceName: getBrandServiceName() },
                icon: NOTIFICATION_ICON.LOCK
            };
            // Delayed so it doesn't overlap the "you're now a moderator" notification, which
            // also fires around join time with the same SHORT timeout — this one takes over
            // right as that one finishes instead of showing at the same time.
            setTimeout(() => {
                dispatch(showNotification(notificationParams, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
            }, NOTIFICATION_TIMEOUT.SHORT);
            break;
        }
    }
    return next(action);
});
